<template>
  <div class="pg-main-layout">
    <Navbar />
    <ShutdownBanner />
    <div
      class="pg-main-layout__content"
      :class="{
        'with-pro-banner': true
      }"
    >
      <component
        v-if="subLayoutData"
        :is="getSubLayoutComponent"
        :layoutProps="getSubLayoutProps"
        :subLayoutData="getChildLayoutData"
      >
        <slot></slot>
      </component>
      <slot v-else></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import BlankLayout from "@/layouts/BlankLayout.vue"
import InstaproWidget from "../components/instapro_widget/InstaproWidget"
import Navbar from "../components/navigation/Navbar"
export default {
  components: {
    InstaproWidget,
    Navbar,
    GoProBanner: () => import("@/components/navigation/banner/GoProBanner"),
    ShutdownBanner: () => import("@/components/navigation/banner/ShutdownBanner"),
  },
  props: {
    layoutProps: {
      type: Object,
      default: () => {
        return {}
      },
    },
    subLayoutData: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters("Util", [
      "hideGoProBanner",
      "hideSaleBanner",
      "loadingSaleBanner",
    ]),
    ...mapGetters("User", ["getUser", "isUserPro"]),
    getSubLayoutComponent () {
      return this.$_.get(this.subLayoutData, "component") || BlankLayout
    },
    getSubLayoutProps () {
      return this.$_.get(this.subLayoutData, "props")
    },
    getChildLayoutData () {
      return this.$_.get(this.subLayoutData, "child")
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_variables.scss";
@import "@/assets/style/_mixins.scss";

.pg-main-layout {
  background-color: $gray;
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .pg-main-layout__content {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/NavLayout.vue